import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/provisionalCertificatePrintRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';
function ProvisionalCertificate({accessToken,setAccessToken,setRefreshFailed  }) {
  const navigate = useNavigate();
  const [rollno,setRollno]=useState('');
  const [error,setError]=useState('');

  const [studentDetails,setStudentDetails]=useState(null);
  const [result,setResult]=useState(null);
   const [name,setName]=useState('');
  const [fatherName,setFatherName]=useState('');
    const [motherName,setMotherName]=useState('');
    const [passYear,setPassYear]=useState('');

  const [isDownloading,setIsDownloading]=useState(false);
  const [isSearching,setIsSearching]=useState(false);
const [selectedIssueDate,setSelectedIssueDate]=useState('');

  const handleGoBack = () => {
    navigate(`/`); 
  };



const handleRollnoChange = (e) => {
    setRollno(e.target.value.toUpperCase()); 
    setStates(null);   
  };

  const setStates=(data)=>{
    if(!data )
    {
      setError('');
      setStudentDetails(null);
      setResult(null);
      setFatherName('');
      setMotherName('');
      setName('');
      setPassYear('');
      setSelectedIssueDate('');
    }
    else{
      if(data.error)
      {
      setError(data.message);
      setStudentDetails(null);
      setResult(null);
     setFatherName('');    setPassYear('');
      setMotherName('');setName('');setSelectedIssueDate('');
      }
      else{
       setError('');
      setStudentDetails(data.studentDetails);
      setResult(data.result);
     setFatherName(data.studentDetails.FatherName);
      setMotherName(data.studentDetails.MotherName);setName(data.studentDetails.name);
      setSelectedIssueDate(data.studentDetails.provisional_certificate_issue_date);
          setPassYear(data.studentDetails.passYear);
      }
    }
  }

    
    async function handleSearch(e)
        {
          e.preventDefault();
          setIsSearching(true);
          setStates(null);
          try{
            const response= await editapi.post('/getProvisionalDetails',{ rollno},{headers:{'Authorization':`Bearer ${accessToken}`}});    
            //alert(JSON.stringify(response.data));
             setStates(response.data);
                      }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/getProvisionalDetails',{ rollno},{headers:{'Authorization':`Bearer ${nat}`}});  
                  //alert(JSON.stringify(response.data));  
                      setStates(response.data);     
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            setIsSearching(false);
          }
        }

 function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }
  async function handleDownloadProvisonalCertificate(e,bg)
    {
      e.preventDefault();
      setIsDownloading(true);
      try{
        //session, batch, semester,bg
        const response= await editapi.post('/printProvisonalCertificate',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await editapi.post('/printProvisonalCertificate',{rollno,bg:'YES'},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
      finally
      {
        setIsDownloading(false);
      }
    }

 async function handleUpdate(e,field,value)
        {
          e.preventDefault();
          try{
            const response= await editapi.post('/updateStudentField',{ rollno,field,value},{headers:{'Authorization':`Bearer ${accessToken}`}});    
            //alert(JSON.stringify(response.data));
             //setStates(response.data);
                      }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/updateStudentField',{ rollno,field,value},{headers:{'Authorization':`Bearer ${nat}`}});  
                  //alert(JSON.stringify(response.data));  
                      //setStates(response.data);     
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            
          }
        }

  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> PROVISIONAL CERTIFICATE</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex items-center justify-center mt-4 ">
                <div
                  className="text-center w-full max-w-[600px]  grid grid-cols-[1fr_3fr_1fr] gap-2 p-1 text-sm align-items-end "
                >
                <label className="px-2 py-2">ROLLNO:</label>

                <input
                                type="text" 
                                name="txtRollno"
                                value={rollno}
                                onChange={handleRollnoChange}
                              className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
                              />
              <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={handleSearch}>
                SEARCH
              </button>

                </div>
        </div>       

<div className="w-full flex flex-col justify-center items-center">
  {isSearching&&(<p>Please wait.....</p>)}
  {error.length>0 && (<p>{error}</p>)}
  {!isSearching && error.length<=0 && studentDetails && result && (
    <>
   
       <div className="flex ph w-full justify-start items-center">
  <label className="w-32">Name:</label>
  <input
    type="text"
    value={name}
    onChange={(e) => setName(e.target.value.toUpperCase())}
    onBlur={(e) => handleUpdate(e,"name",e.target.value.toUpperCase())}
    className="border-b border-gray-200 focus:border-green-500 focus:outline-none px-2 py-1 w-full bg-transparent font-semibold text-blue-700"
  />
        </div>

        <div className="flex ph w-full justify-start items-center mt-2">
          <label className="w-32">Father Name:</label>
          <input
            type="text"
            value={fatherName}
            onChange={(e) => setFatherName(e.target.value.toUpperCase())}
            onBlur={(e) => handleUpdate(e,"FatherName",e.target.value.toUpperCase())}
            className="border-b border-gray-200 focus:border-green-500 focus:outline-none px-2 py-1 w-full bg-transparent font-semibold  text-blue-700"
          />
        </div>

        <div className="flex ph w-full justify-start items-center mt-2">
          <label className="w-32">Mother Name:</label>
          <input
            type="text"
            value={motherName}
            onChange={(e) => setMotherName(e.target.value.toUpperCase())}
            onBlur={(e) => handleUpdate(e,"MotherName",e.target.value.toUpperCase())}
            className="border-b border-gray-200 focus:border-green-500 focus:outline-none px-2 py-1 w-full bg-transparent font-semibold text-blue-700"
          />
        </div>
       <div className="flex ph w-full justify-start items-center mt-2">
          <label className="w-32">Pass Year:</label>
          <input
            type="text"
            value={passYear}
            onChange={(e) => setPassYear(e.target.value)}
            onBlur={(e) => handleUpdate(e,"passYear",e.target.value)}
            className="border-b border-gray-200 focus:border-green-500 focus:outline-none px-2 py-1 w-full bg-transparent font-semibold text-blue-700"
          />
        </div>
<div className="flex ph w-full justify-start items-center mt-2">
      <label>last Exam Year:</label>
      <p className=" text-blue-700 font-semibold">{`${result.year}`}</p>
    </div>

    <div className="flex ph w-full justify-start items-center mt-2">
      <label>Programme:</label>
      <p className=" text-blue-700 font-semibold">{studentDetails.programme_code}</p>
    </div>
    <div className="flex ph w-full justify-start items-center mt-2">
      <label>Major:</label>
      <p className=" text-blue-700 font-semibold">{studentDetails.fullMajorName}</p>
    </div>
    <div className="flex ph w-full justify-start items-center mt-2">
      <label>Duration:</label>
      <p className=" text-blue-700 font-semibold">{`${studentDetails.duration.startYear} to ${studentDetails.duration.endYear}`}</p>
    </div>
    

    <div className="flex ph w-full justify-start items-center mt-2">
      <label>Major CGPA:</label>
      <p className=" text-blue-700 font-semibold">{`${result.majorCgpa}`}</p>
    </div>
    <div className="flex ph w-full justify-start items-center mt-2">
      <label>All CGPA:</label>
      <p className=" text-blue-700 font-semibold">{`${result.allCgpa}`}</p>
    </div>


<div className="flex ph w-full justify-start items-center mt-2">
      <label>creditRequired:</label>
      <p className=" text-blue-700 font-semibold">{`${result.creditRequired}`}</p>
    </div>


<div className="flex ph w-full justify-start items-center mt-2">
      <label>totalCreditEarned:</label>
      <p className=" text-blue-700 font-semibold">{`${result.totalCreditEarned}`}</p>
    </div>


    <div className="flex ph w-full justify-start items-center mt-2">
      <label>CompletionStatus:</label>
     <p className={`font-semibold ${
  result.completionStatus.toUpperCase() === 'COMPLETED' 
    ? 'text-green-600' 
    : 'text-red-600'
}`}>
  {result.completionStatus}
</p>

    </div>



<div className="flex  w-full justify-center items-center mt-2  p-2">
 <h2 className=" font-semibold text-gray-800">Issue Date:</h2>
       
        <input
            type="date"
            value={selectedIssueDate}
            className={`w-full max-w-[200px] w-[99%] px-2 bg-transparent border-b-2 border-gray-200 focus:border-red-700 focus:outline-none transition-colors duration-300`}
            onChange={(e)=>setSelectedIssueDate(e.target.value)}
             onBlur={(e) => handleUpdate(e,"provisional_certificate_issue_date",e.target.value)}
          />
</div>
<div className="flex  w-full justify-center items-center mt-3 ">
    <button
  disabled={result.completionStatus.toUpperCase() !== 'COMPLETED'}
  className={`${
    result.completionStatus.toUpperCase() !== 'COMPLETED'
      ? 'bg-gray-400 cursor-not-allowed'
      : 'bg-blue-500 hover:bg-blue-600 hover:scale-105 active:scale-95'
  } 
  text-xs text-white font-semibold px-6 py-2 rounded-md shadow-md transition-all duration-300`}
  onClick={(e) => handleDownloadProvisonalCertificate(e, 'yes')}
>
  DOWNLOAD CERTIFICATE
</button></div>

    </>
  )}
</div>
      </div>
      </div>
    </main>
  );
}

export default ProvisionalCertificate;
